Shopify.queryParams = {};

function refreshCollectionPageWithFilters(url_filters) {
	let currentUrl = '//' + location.host + location.pathname;
	let newPageString = httpGet(currentUrl + '?' + url_filters);
	let newPageEl = document.createElement('DIV');
	newPageEl.innerHTML = newPageString;

	let newSection = newPageEl.querySelector('.mm-template-collection-grid');
	let newElemsFiltersInner = newPageEl.querySelectorAll('.filter-group-display__list');
	let newActiveFiltersCounts = newPageEl.querySelectorAll('.mm-collection-filter-label');

	document.querySelector('.mm-template-collection-grid').innerHTML = newSection.innerHTML;
	newElemsFiltersInner.forEach(function (newElemFiltersInner, index) {
		document.querySelectorAll('.filter-group-display__list').forEach(function (elem, elemIndex) {
			if (index == elemIndex) {
				elem.innerHTML = newElemFiltersInner.innerHTML;
			}
		});
	});
	newActiveFiltersCounts.forEach(function (newActiveFiltersCount, index) {
		document.querySelectorAll('.mm-collection-filter-label').forEach(function (elem, elemIndex) {
			if (index == elemIndex) {
				elem.outerHTML = newActiveFiltersCount.outerHTML;
			}
		});
	});

	var newProductsCount = newPageEl.querySelector('.mm-products-count');
	document.querySelector('.mm-products-count').innerHTML = newProductsCount.innerHTML;

	var displayProductsButton = newPageEl.querySelector('#mmDisplayProducts');
	document.querySelector('#mmDisplayProducts').innerHTML = displayProductsButton.innerHTML;

	var displayProductsButton = newPageEl.querySelector('.mm-collection-filter-reset');
	document.querySelector('.mm-collection-filter-reset').outerHTML = displayProductsButton.outerHTML;  

	window.history.replaceState(null, document.title, currentUrl + '?' + url_filters);
    mmRemoveLoaderFromGrid();
    mmRemoveLoaderFromFilters();
	checkForChanges();
}

function httpGet(theUrl) {
	var xmlHttp = null;

	xmlHttp = new XMLHttpRequest();
	xmlHttp.open('GET', theUrl, false);
	xmlHttp.send(null);
	return xmlHttp.responseText;
}

function checkForChanges() {
	var form = document.getElementById('collectionFacetsForm');
	var inputs = form.querySelectorAll('input:not(.mm-collection-filter-radio)');

	inputs.forEach(function (input) {
		input.addEventListener('change', function (e) {
          mmShowLoaderOnGrid();
          mmShowLoaderOnFilters();
          setTimeout(() => {
			fakeSubmitForm();
          }, "10");
		});
	});
}

document.querySelectorAll('input.mm-collection-filter-radio').forEach(function(radio) {
    radio.addEventListener('change', function (e) {
        var value = e.target.value;
        Shopify.queryParams.sort_by = value;
        
        // Créez une nouvelle URL avec les paramètres de requête mis à jour
        var newUrl = new URL(window.location.href);
        newUrl.search = new URLSearchParams(Shopify.queryParams).toString();
        
        // Ajoutez l'ancre désirée
        newUrl.hash = 'mmCollectionGridHeader';

        // Rechargez la page avec la nouvelle URL
        location.href = newUrl.toString();
    });
});

document.addEventListener('DOMContentLoaded', function () {
    // Vérifiez si l'URL contient le paramètre 'sort_by'
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('sort_by')) {
        // Effectuez une action si le paramètre 'sort_by' est présent
        document.querySelector('.mm-collection-filter-accordeon-sort-by-in-filters .mm-collection-filter-accordeon-top').classList.add('mm-active');
    }
});


function mmShowLoaderOnGrid() {
  document.querySelector('.mm-template-collection-grid').classList.add('mm-loading');
}
function mmRemoveLoaderFromGrid() {
  document.querySelector('.mm-template-collection-grid').classList.remove('mm-loading');
}
function mmShowLoaderOnFilters() {
  document.querySelector('#collectionFacetsForm').classList.add('mm-loading');
}
function mmRemoveLoaderFromFilters() {
  document.querySelector('#collectionFacetsForm').classList.remove('mm-loading');
}
function mmScrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth' // Utiliser 'smooth' pour un défilement fluide
  });
}

function fakeSubmitForm() {  
    // Sélectionne le formulaire par son ID
    let form = document.getElementById('collectionFacetsForm');
    
    // Serialize le formulaire
    let formData = new FormData(form);
    let url_filters = new URLSearchParams(formData).toString();
    
    // Appelle la fonction pour rafraîchir la page avec les filtres
    refreshCollectionPageWithFilters(url_filters);
}

function mmToggleFilters() {
  const filtersMenu = document.querySelector('.mm-template-collection-filters');

  filtersMenu.classList.toggle('mm-visible');
}

window.addEventListener('DOMContentLoaded', (event) => {
	checkForChanges();
});

function mmResetFilters() {
  let currentUrl = '//' + location.host + location.pathname;
  window.location.href = currentUrl;
}

// PRICE RANGE ======================================================================================================

const minRange = document.getElementById('min-range');
const maxRange = document.getElementById('max-range');
const sliderTrack = document.querySelector('.slider-track');
const minRangeValue = document.getElementById('min-range-value');
const maxRangeValue = document.getElementById('max-range-value');

function updateRange() {
    const minValue = parseInt(minRange.value);
    const maxValue = parseInt(maxRange.value);

    minRangeValue.innerHTML = `${minValue}<span>€</span>`;
    maxRangeValue.innerHTML = `${maxValue}<span>€</span>`;

    const minPercent = (minValue / minRange.max) * 100;
    const maxPercent = (maxValue / maxRange.max) * 100;

    sliderTrack.style.background = `linear-gradient(to right, #ddd ${minPercent}%, orange ${minPercent}%, orange ${maxPercent}%, #ddd ${maxPercent}%)`;

    minRangeValue.style.left = `${minPercent}%`;
    maxRangeValue.style.left = `${maxPercent}%`;
}

minRange.addEventListener('input', function() {
    if (parseInt(minRange.value) > parseInt(maxRange.value) - 10) {
        minRange.value = maxRange.value - 10;
    }
    updateRange();
});

maxRange.addEventListener('input', function() {
    if (parseInt(maxRange.value) < parseInt(minRange.value) + 10) {
        maxRange.value = parseInt(minRange.value) + 10;
    }
    updateRange();
});

updateRange(); // Initialize range

/* GRAB COLLECTIONS SCROLL ================================================================================ */

function mmDragAndDropCollections() {
  const slider = document.getElementById('linked-collections-wrapper');
  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('active');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('active');
  });

  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('active');
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 3; // Multiply by 3 for faster scroll
    slider.scrollLeft = scrollLeft - walk;
  });
}
//mmDragAndDropCollections();